import { render } from "./NewRole.vue?vue&type=template&id=50cbceac&scoped=true"
import script from "./NewRole.vue?vue&type=script&lang=js"
export * from "./NewRole.vue?vue&type=script&lang=js"

import "./NewRole.vue?vue&type=style&index=0&id=50cbceac&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50cbceac"]])

export default __exports__